import React, { useState } from "react";
import { theme, Tooltip, Badge, Modal, Flex, Button } from "antd";
import {  PlusCircleOutlined,  MinusCircleOutlined,  SwapOutlined,  EditOutlined,  ExclamationCircleOutlined,  StopFilled, DownloadOutlined, FileSearchOutlined, CheckCircleFilled, MinusCircleFilled, FilePdfOutlined} from "@ant-design/icons";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { GRAY_COLOR, LAB_COLOR, ORANGE_COLOR, PRIMARY_COLOR, PRINT_COLOR } from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDroplet, faFlask, faStore } from "@fortawesome/free-solid-svg-icons";
import { URL_SALE, URL_TANK } from "../../constants/urls";
import StorageTankOpenLotModal from "./StorageTankOpenLotModal";
import StorageTankStatusLogModal from "./StorageTankStatusLogModal";
import {  LAB_ORDER_TYPE,  PRODUCT_TYPE,  TANK_ACTION,  TANK_STATUS,  TANK_STATUS_TH, } from "../../constants/string";
import _ from "lodash";
import StorageTankWeightLogModal from "./StorageTankWeightLogModal";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../routes/CustomRoutes";
import StorageTankCloseModal from "./StorageTankCloseModal";
import StorageTankWeightPopover from "./StorageTankWeightPopover";
import { GET, POST } from "../../frameworks/HttpClient";
import StorageTankTransferTransactionModal from "./StorageTankTransferTransactionModal";
import ErrorMessages from "../../common/ErrorMessages";
import StorageTankImportModal from "./StorageTankImportModal";
import { formatComma, toFixed } from "../../frameworks/Util";
import StorageTankWaitingOrderListModal from "./StorageTankWaitingOrderListModal";
import TankLabModal from "./TankLabModal";
import { useMenuNotificationContext } from "../../hooks/MenuNotificationProvider";

export default function StorageTankList() {
  const [targetTankOpenLotModal, setTargetTankOpenLotModal] = React.useState(null);
  const [targetStatusLog, setTargetStatusLog] = React.useState(false);
  const [targetWeightLog, setTargetWeightLog] = React.useState(null);
  const [targetCloseTank, setTargetCloseTank] = React.useState(null);
  const [storageTankTransferTransactionModal, setStorageTankTransferTransactionModal] = React.useState(null);
  const [openStorageTankImportModal, setOpenStorageTankImportModal,  ] = React.useState(false);
  const navigate = useNavigate();
  const tableRef = React.useRef(null);
  const { token: { colorWarning, colorSuccess, colorPrimary }, } = theme.useToken();
  const [errorMessages , setErrorMessages] = useState(null);
  const [productOrderCount, setProduceOrderCount] = useState(0);
  const [openProduceOrderListModal, setOpenProduceOrderListModal] = useState(null);
  const [openLabTankModal, setOpenLabTankModal] = useState(false);
  const { notification } = useMenuNotificationContext();

  const refreshData = async () => { 
    if (tableRef.current){
      await tableRef.current.fetchWithoutResetPage();
      fetchProduceOrderCount();
    }};

  const confirm = (title, value) => {
    Modal.confirm({
      title: `เปิดแทงก์ขาย - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color: PRIMARY_COLOR }} />,
      content: "คุณต้องการเปิดแทงก์เพื่อขายใช่หรือไม่ ?",
      okText: "ใช่",
      cancelText: "ปิด",
      maskClosable: true,
      okButtonProps: { style: { backgroundColor: PRIMARY_COLOR } },
      onOk: async () => {
        await handleOpenTankSell(value);
        refreshData();
      },
      onConfirm: () => refreshData(),
    });
  };

  const fetchProduceOrderCount = async() => {
    try{
      const filter = { page_size: 999, type: PRODUCT_TYPE.CONCENTRATE_LATEX, is_produced : false }
      const response = await GET(URL_SALE.PRODUCE_ORDER, filter)
      setProduceOrderCount(response.data.total)
    } catch(error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const confirmEnd = (title, value) => {
    Modal.confirm({
      title: `จบการทำงาน - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color: PRIMARY_COLOR }} />,
      content: "คุณต้องการจบการทำงานล็อตน้ำยางข้นนี้ใช่หรือไม่ ?",
      okText: "ใช่",
      cancelText: "ปิด",
      maskClosable: true,
      okButtonProps: { style: { backgroundColor: PRIMARY_COLOR } },
      onOk: () => {
        handleEndWork(value);
      },
      onConfirm: () => refreshData(),
    });
  };

  const handleOpenTankSell = async (id) => {
    setErrorMessages(null);
    try {
      const data = { action: TANK_ACTION.SELL };
      await POST(`${URL_TANK.TANK_TRANSACTION}${id}/change-state/`, data);
      refreshData();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const handleEndWork = async (id) => {
    setErrorMessages(null);
    try {
      const data = { action: TANK_ACTION.END };
      await POST(`${URL_TANK.TANK_TRANSACTION}${id}/change-state/`, data);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      render: (_, original) => {
        return (
          <div
            style={{ textAlign: "center" }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {!original.state && (
              <Tooltip triger='hover' title={"เปิดแทงก์"}>
                <ColorButton
                  type="primary"
                  style={{ marginLeft: 10 }}
                  override={PRIMARY_COLOR}
                  icon={<PlusCircleOutlined />}
                  onClick={() => setTargetTankOpenLotModal(original)}
                />
              </Tooltip>
            )}

          {original.state === TANK_STATUS.FILLING &&
            <Tooltip triger='hover' title={"แก้ไข"}>
              <ColorButton 
                type='primary'
                style={{ marginLeft : 10}}
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={()=> setTargetTankOpenLotModal(original)} 
              />
            </Tooltip>}

            {original.state === TANK_STATUS.FILLING && (
              <Tooltip triger='hover' title={"เติมน้ำยาง"}>
                <ColorButton
                  type="primary"
                  style={{ marginLeft: 10 }}
                  override={colorSuccess}
                  icon={<FontAwesomeIcon icon={faDroplet} />}
                  onClick={() =>
                    navigate(
                      `${PATH.STORAGE_TANK_FILL}/${original.current_transaction}/`
                    )
                  }
                />
              </Tooltip>
            )}

            {(original.state === TANK_STATUS.FILLING ||
              original.state === TANK_STATUS.CLOSED ||
              original.state === TANK_STATUS.SELLING) && (
              <Badge count={original.is_input_progressing ? '!' : 0} size={'small'}>
                <Tooltip triger='hover' title={"แล็บแทงก์"}>
                  <ColorButton
                    type="primary"
                    override={LAB_COLOR}
                    style={{ marginLeft: 10 }}
                    icon={<FontAwesomeIcon icon={faFlask} />}
                    onClick={() =>
                      navigate(
                        `${PATH.POND_LAB}/${original.current_transaction}/${LAB_ORDER_TYPE.TANK}/`
                      )
                    }
                  />
                </Tooltip>
              </Badge>
            )}

            {original.state === TANK_STATUS.FILLING && (
              <Tooltip triger='hover' title={"ปิดแทงก์"}>
                <ColorButton
                  type="primary"
                  style={{ marginLeft: 10 }}
                  override={colorWarning}
                  icon={<MinusCircleOutlined />}
                  onClick={() => setTargetCloseTank(original)}
                />
              </Tooltip>
            )}

            {original.state === TANK_STATUS.CLOSED && (
              <Tooltip triger='hover' title={"ขาย"}>
                <ColorButton
                  type="primary"
                  style={{ marginLeft: 10 }}
                  override={colorSuccess}
                  icon={<FontAwesomeIcon icon={faStore} />}
                  onClick={() =>
                    confirm(original.lot_no, original.current_transaction)
                  }
                />
              </Tooltip>
            )}

            {original.state === TANK_STATUS.SELLING && (
              <Tooltip triger='hover' title={"จบการทำงาน"}>
                <ColorButton
                  type="primary"
                  override={GRAY_COLOR}
                  style={{ marginLeft: 10 }}
                  icon={<StopFilled />}
                  onClick={() =>
                    confirmEnd(original.lot_no, original.current_transaction)
                  }
                />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "แทงก์",
      dataIndex: "name",
      key: "name",
      searcher : true,
    },
    {
      title: "Lot No.",
      dataIndex: "lot_no",
      key: "lot_no",
      render : (value, original) => value ? 
        <>
          {value}
          <Tooltip triger='hover' title='รายละเอียดสต๊อกน้ำยางข้น'>
            <Button type='link' icon={<FilePdfOutlined />} onClick={() => window.open(`${window.origin}${PATH.TANK_SUMMARY}/${original.current_transaction}`)}/>
          </Tooltip>
        </> : '-'
      },
    // {
    //   title: "ใบแจ้งผลิต",
    //   dataIndex: "",
    //   key: "",
    // },
    {
      title: "เกรด",
      dataIndex: "product_name",
      key: "product_name",
    },
    {
      title: "น้ำหนัก",
      dataIndex: "current_weight",
      key: "current_weight",
      render: (value, original) => {
        return (
          <center>
            {value ? (
              <Tooltip triger='hover' title={"ประวัติเปลี่ยนน้ำหนัก"}>
                <a
                  onClick={() =>
                    setTargetWeightLog(original.current_transaction)
                  }
                >
                  {formatComma(toFixed(value, 0))}
                </a>
              </Tooltip>
            ) : (
              "-"
            )}
            {_.get(original, "current_transaction", "null") && (
              <StorageTankWeightPopover
                title={"น้ำหนักน้ำยางข้น"}
                target={original}
                onUpdate={() => refreshData()}
              >
                <Tooltip triger='hover' title={"กรอกน้ำหนัก"}>
                  <EditOutlined
                    style={{ color: colorWarning, marginLeft: 5 }}
                  />
                </Tooltip>
              </StorageTankWeightPopover>
            )}
          </center>
        );
      },
    },
    {
      title: "มีใบแจ้งผลิต",
      dataIndex: "order_ref",
      key: "order_ref",
      render:(value, option) => 
        <center> 
          {option.current_transaction &&
            (value ? 
              <Tooltip title={
                <div>
                  Contract No. : {option.sale_order_no}<br/>
                  ล็อตใบแจ้งผลิต : {option.produce_lot_no}
                </div>
              }>
                <CheckCircleFilled style={{color : colorSuccess, fontSize : 16}}/> 
              </Tooltip>
            : 
              <Tooltip title={'ยังไม่ได้ผูกกับใบแจ้งผลิต'}>
                <MinusCircleFilled style={{color : colorWarning, fontSize : 16}}/>
              </Tooltip>
            )
          }
        </center> 
    },
    {
      title: "น้ำหนักแจ้งผลิต",
      dataIndex: "produce_order_weight",
      render: (value) => value ? formatComma(value) : '',
    },
    {
      title: "สถานะ",
      dataIndex: "state",
      key: "state",
      render: (value, original) => {
        return (
          <>
            {value ? (
              <Tooltip triger='hover' title={"ประวัติเปลี่ยนสถานะ"}>
                <a
                  onClick={() =>
                    setTargetStatusLog(original.current_transaction)
                  }
                >
                  {TANK_STATUS_TH[value]}
                </a>
              </Tooltip>
            ) : (
              "-"
            )}
          </>
        );
      },
    },
  ];

  React.useEffect(() => {
    fetchProduceOrderCount();
  },[])

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <Flex gap="middle" justify="flex-end" style={{ marginBottom: "0.5rem" }}>
        <Badge count={notification.tank}>
          <ColorButton
            type="primary"
            override={LAB_COLOR}
            icon={<FontAwesomeIcon icon={faFlask}/>}
            onClick={() => setOpenLabTankModal(true)}>
            แทงก์รอเติมสารเคมี
          </ColorButton>
        </Badge>
        <Badge count={productOrderCount}>
          <ColorButton
            type={"primary"}
            override={PRINT_COLOR}
            icon={<FileSearchOutlined />}
            onClick={() => {
              setOpenProduceOrderListModal(true);
            }}
          >
            รายการรอผลิต
          </ColorButton>
        </Badge>
        <ColorButton
          type={"primary"}
          override={colorSuccess}
          icon={<DownloadOutlined />}
          onClick={() => {
            setOpenStorageTankImportModal(true);
          }}
        >
          นำเข้าน้ำยางข้น
        </ColorButton>
        <ColorButton
          type={"primary"}
          override={colorPrimary}
          icon={<SwapOutlined />}
          onClick={() => {
            setStorageTankTransferTransactionModal(true);
          }}
        >
          โอนย้ายแทงก์
        </ColorButton>
      </Flex>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_TANK.TANK}
        rowClassName={(record) => {
          if (record.is_input_progressing) {
            return "table-row-red";
          }
        }}
      />
      <StorageTankTransferTransactionModal
        open={storageTankTransferTransactionModal ? true : false}
        onClose={() => setStorageTankTransferTransactionModal(false)}
        onUpdate={() => {
          setStorageTankTransferTransactionModal(false);
          refreshData();
        }}
      />

      <StorageTankImportModal
        open={openStorageTankImportModal}
        onClose={() => setOpenStorageTankImportModal(false)}
        onUpdate={() => {
          setOpenStorageTankImportModal(false);
          refreshData();
        }}
      />

      <StorageTankOpenLotModal
        open={targetTankOpenLotModal ? true : false}
        onClose={() => setTargetTankOpenLotModal(false)}
        target={targetTankOpenLotModal}
        onUpdate={() => {
          setTargetTankOpenLotModal(false);
          refreshData();
        }}
      />

      <StorageTankStatusLogModal
        open={targetStatusLog ? true : false}
        onClose={() => setTargetStatusLog(false)}
        target={targetStatusLog}
        onUpdate={() => {
          setTargetStatusLog(null);
          refreshData();
        }}
      />

      <StorageTankCloseModal
        open={targetCloseTank ? true : false}
        onClose={() => setTargetCloseTank(null)}
        target={targetCloseTank}
        onUpdate={() => {
          setTargetCloseTank(null);
          refreshData();
        }}
      />

      <StorageTankWeightLogModal
        open={targetWeightLog ? true : false}
        target={targetWeightLog}
        onClose={() => setTargetWeightLog(null)}
      />

      <StorageTankWaitingOrderListModal
        open={openProduceOrderListModal}
        onClose={() => setOpenProduceOrderListModal(false)}
        onUpdate={() => 
          setOpenProduceOrderListModal(false)
        }
      />

      <TankLabModal
        open={openLabTankModal}
        onCancel={() => setOpenLabTankModal(false)}/>
    </div>
  );
}